import type { PropsWithChildren } from "react";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type ImportantNoteProps = {
  className?: string;
};

function ImportantNote({ className, children }: PropsWithChildren<ImportantNoteProps>) {
  return (
    <Typography variant="text-md" weight="bold" className={cn("mb-4 text-primary-600", className)}>
      {children}
    </Typography>
  );
}

ImportantNote.displayName = "ImportantNote";

export { ImportantNote };
